'use strict';
exports.__esModule = true;

const _ = require('lodash');
const atomic = require('../../git_modules/@tomandco/atomic/config');
const { button } = require('./atomic/button');
const { color, namedColor } = require('./atomic/color');
const { gridSize, itemsInRow } = require('./atomic/grid');
const { icons } = require('./atomic/icons');
const { input } = require('./atomic/input');
const { ratio } = require('./atomic/ratio');
const { fontFamily, fontWeight, textStyle } = require('./atomic/typography');
const { componentSize } = require('./atomic/component');

/**
 * @internal
 */
const colorDefault = _.find(color, { key: '1' }).value;
const fontFamilyDefault = _.find(fontFamily, { key: '1' }).value;
const borderColorDefault = _.find(color, { key: '4' }).value;

// Export none converted options to iCMS, but with atomic prefixes
exports.color = atomic.assignKeyPrefix(color, atomic.PREFIX.color);
exports.backgroundColor = atomic.assignKeyPrefix(color, atomic.PREFIX.backgroundColor);
exports.ratio = atomic.assignKeyPrefix(ratio, atomic.PREFIX.ratio);
exports.fontFamily = atomic.assignKeyPrefix(fontFamily, atomic.PREFIX.fontFamily);
exports.input = input;
exports.fontWeight = atomic.assignKeyPrefix(fontWeight, atomic.PREFIX.fontWeight);
exports.button = button;
exports.gridSize = gridSize;
exports.itemsInRow = itemsInRow;
exports.textStyle = textStyle;
exports.icons = icons;

/**
 * Every section of the config file is optional, so you only have to specify what you'd like to change.
 * Any missing sections will fall back to Atomic default configuration.
 */
exports.config = _.defaultsDeep(
    {
        breakpoint: {
            x: {
                limit: {
                    min: 0,
                    max: 10 // in %
                }
            }
        },
        size: {
            s: '4px',
            m: '5px',
            l: '6px',
            x: '7px'
        },
        color: atomic.convert(color),
        namedColor: namedColor,
        background: {
            color: atomic.convert(color)
        },
        body: {
            background: {
                color: 'transparent'
            },
            color: colorDefault,
            font: {
                family: fontFamilyDefault,
                weight: fontWeight.regular
            }
        },
        border: {
            radius: {
                custom: [4, 5, 7, 10]
            },
            color: {
                default: borderColorDefault,
                ...atomic.convert(color)
            },
            width: {
                custom: [3]
            }
        },
        // grid
        grid: {
            gutter: {
                size: {
                    s: '2px',
                    m: '3px',
                    l: '3px',
                    x: '4px'
                }
            }
        },
        // layout
        layout: {
            width: '2504px'
        },
        // typography
        typography: {
            size: {
                s: '16px',
                m: '16px',
                l: '16px',
                x: '16px'
            },
            font: {
                family: atomic.convert(fontFamily),
                weight: atomic.convert(fontWeight)
            }
        },
        margin: {
            max: 12,
            custom: [-4, -2, -1, 14, 16, 20]
        },
        padding: {
            max: 10,
            custom: [12, 20, 40]
        },
        // position
        position: {
            custom: [-3, -2, 5, 6, 7, 8]
        },
        // ratio
        ratio: atomic.convert(ratio),
        // component
        component: {
            size: atomic.convert(componentSize)
        },
        // animations
        animation: {
            hideUp: {
                custom: [50]
            }
        }
    },
    atomic.config
);
